import { createSearchParams, type To } from "react-router-dom";

const SEARCH_KEYS = ["query", "title", "author", "publication", "tags", "languages"] as const;

export type BackToOptions = {
    defaultPathname?: string; // default: ".."
    searchPathname?: string; // default: "../search"
    preserveKeys?: string[]; // default: ["page", "tag"]
};

function hasSearchParams(params: URLSearchParams): boolean {
    return SEARCH_KEYS.some((k) => params.get(k));
}

export function buildBackTo(search: string, options?: BackToOptions): To {
    const params = new URLSearchParams(search);

    const searchPathname = options?.searchPathname ?? "../search";
    const defaultPathname = options?.defaultPathname ?? "..";
    const preserveKeys = options?.preserveKeys ?? ["page", "tag"];

    if (hasSearchParams(params)) {
        // Return to search with the full, original query string preserved
        return { pathname: searchPathname, search } as const;
    }

    // Otherwise, only preserve a small allowlist of params
    const out: Record<string, string> = {};
    for (const key of preserveKeys) {
        const val = params.get(key);
        if (val) {
            out[key] = val;
        }
    }

    const s = createSearchParams(out).toString();
    return { pathname: defaultPathname, search: s ? `?${s}` : "" } as const;
}
